import React, { useEffect } from 'react';
import { Row, Col, Button } from 'antd';
import { initializeSurveyExam } from '../../services/testPage';
import { handlers } from '../../helpers/helpers';

const GroupDetail = ({ group, setStep, onReturn, disabledBack }) => {
  useEffect(() => {
    let isMounted = true;
    const initializeExam = async () => {
      if (['created', 'reevaluate'].includes(group.admission_patient_exam_state)) {
        try {
          await initializeSurveyExam({ admissionPatientExamId: group.admission_patient_exam });
          if (isMounted) handlers.markSurveysAsInitialized(group);
        } catch (error) {
          if (isMounted) console.error('Error initializing exam:', error);
        }
      }
    };
    initializeExam();
    return () => {
      isMounted = false;
    };
  }, [group.admission_patient_exam, group.admission_patient_exam_state]);

  const goToQuestion = () => {
    setStep(3);
  };

  return (
    <Row justify="center" className="group-detail-container mt-80">
      <Col lg={20} md={20}>
        {group && (
          <React.Fragment>
            <h1 className="text-center mb-30">{group.name}</h1>
            <p dangerouslySetInnerHTML={{ __html: group.description }} />
          </React.Fragment>
        )}
      </Col>
      <Col md={22} className="mt-100 mb-30">
        <Row justify="space-between">
          <Col md={5}>
            <Button disabled={disabledBack} className={disabledBack ? 'button-disabled' : 'secondary-button'} size="large" onClick={onReturn} block>
              Anterior
            </Button>
          </Col>
          <Col md={5}>
            <Button type="primary" onClick={goToQuestion} size="large" block>
              Continuar
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default GroupDetail;
